import React, { useState } from "react";
import {
  IconButton,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import { t } from "i18next";
import { useSelector } from "react-redux";
import {
  useAssociaUserMutation,
  useDissociaUserMutation,
} from "../../../../features/api/admin/gestisciCommercialistiApi";
import { toast } from "react-toastify";
import { useGetUsersQuery } from "../../../../features/api/admin/gestisciUtentiApi";
import { TABLE_ROWS_NUMBER } from "../../../../utils/constants/tables";
import UserFilter from "../UserFilter/UserFilter";
import CoreButtonIcon from "../CoreButtonIcon/CoreButtonIcon";
import PersonAddAltRoundedIcon from "@mui/icons-material/PersonAddAltRounded";
import {
  useAssociaUserStudioMutation,
  useDissociaUserStudioMutation,
} from "../../../../features/api/admin/gestisciStudioApi";

const AssociateTableUser = ({ userData = [], adminId, studioId }) => {
  const [selectedUser, setSelectedUser] = useState();
  const [debouncedInputUserValue, setDebouncedInputUserValue] = useState("");
  const [page, setPage] = useState({
    currentPage: 1,
    startRow: 0,
    endRow: TABLE_ROWS_NUMBER,
  });

  const colorPrimary = useSelector((state) => state.app.primaryColor);

  const {
    data: users,
    isLoading: isLoadingUsers,
    isFetching: isFetchingUsers,
  } = useGetUsersQuery({ page, value: debouncedInputUserValue });

  const [associaUser, { isLoading: isLoadingAssocia }] =
    useAssociaUserMutation();
  const [dissociaUser, { isLoading: isDisassociatedLoading }] =
    useDissociaUserMutation();

  const [associaUserStudio, { isLoading: isLoadingAssociaStudio }] =
    useAssociaUserStudioMutation();
  const [dissociaUserStudio, { isLoading: isDisassociatedLoadingStudio }] =
    useDissociaUserStudioMutation();

  const handleassociated = () => {
    associaUser({
      adminId: adminId,
      userId: selectedUser.id,
      userEmail: selectedUser.email,
    })
      .unwrap()
      .then((res) => {
        if (res.Exception) {
          toast.error(res.Exception);
        } else if (res.Data) {
          toast.success(t("UserAssociated"));
          setSelectedUser();
          setDebouncedInputUserValue();
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const handleDisassociateUser = (el) => {
    const disassociateData = {
      adminId: el.adminId,
      userId: el.id,
      userEmail: el.email,
    };
    dissociaUser(disassociateData).then((res) => {
      if (res.data.Result === 1) {
        toast.success(t("UserUnassociated"));
      } else {
        toast.error(res.data.Exception);
      }
    });
  };

  const handleassociatedStudio = () => {
    associaUserStudio({
      studioId: studioId,
      userId: selectedUser.id,
    })
      .unwrap()
      .then((res) => {
        if (res.Exception) {
          toast.error(res.Exception);
        } else if (res.Data) {
          toast.success(t("UserAssociated"));
          setSelectedUser();
          setDebouncedInputUserValue();
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const handleDisassociateUserStudio = (el) => {
    const disassociateData = {
      studioId: studioId,
      userId: el.id,
    };
    dissociaUserStudio(disassociateData).then((res) => {
      if (res.data.Result === 1) {
        toast.success(t("UserUnassociated"));
      } else {
        toast.error(res.data.Exception);
      }
    });
  };

  return (
    <div>
      <h3 className="flex">
        {t("UsersAssociated")}
        <div
          className="w-6 h-6 mx-4 rounded-3xl"
          style={{ backgroundColor: `${colorPrimary}` }}
        >
          <small className="text-white flex justify-center">
            {userData?.length}
          </small>
        </div>
      </h3>

      <div className="py-6 flex space-x-2">
        <div className="w-full">
          <UserFilter
            selectedUser={selectedUser}
            setSelectedUser={setSelectedUser}
            usersList={users?.Data?.items}
            setDebouncedInputUserValue={setDebouncedInputUserValue}
            isUsersLoading={isLoadingUsers || isFetchingUsers}
          />
        </div>
        <div>
          <CoreButtonIcon
            className={
              !selectedUser ||
              (adminId ? isLoadingAssocia : isLoadingAssociaStudio)
                ? "text-gray-600"
                : "text-blue-600  "
            }
            icon={
              <PersonAddAltRoundedIcon
                fontSize="small"
                className={
                  !selectedUser ||
                  (adminId ? isLoadingAssocia : isLoadingAssociaStudio)
                    ? "text-gray-600"
                    : "text-blue-600  "
                }
              />
            }
            disabled={
              !selectedUser ||
              (adminId ? isLoadingAssocia : isLoadingAssociaStudio)
            }
            testo={t("Associate")}
            onClick={studioId ? handleassociatedStudio : handleassociated}
          />
        </div>
      </div>

      <TableContainer
        component={Paper}
        elevation={4}
        style={{ maxHeight: "35rem" }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{t("Name")}</TableCell>
              <TableCell>{t("Surname")}</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>{t("Actions")}</TableCell>
            </TableRow>
          </TableHead>

          {userData?.map((el) => (
            <TableRow className="hover:shadow-md" key={el.id}>
              <TableCell>{el.name}</TableCell>
              <TableCell>{el.surname}</TableCell>
              <TableCell>{el.email}</TableCell>

              <TableCell>
                <IconButton
                  variant="outlined"
                  onClick={() =>
                    studioId
                      ? handleDisassociateUserStudio(el)
                      : handleDisassociateUser(el)
                  }
                  disabled={
                    adminId
                      ? isDisassociatedLoading
                      : isDisassociatedLoadingStudio
                  }
                >
                  <HighlightOffRoundedIcon
                    fontSize="small"
                    className="text-rose-700"
                  />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </Table>
        {userData?.length === 0 && (
          <p className="flex justify-center py-2 text-gray">{t("NoUsers")}</p>
        )}
      </TableContainer>
    </div>
  );
};

export default AssociateTableUser;
